export default "__VITE_ASSET__Bz0A8mwH__"